import React from "react";
import { FileText } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import ProformaForm from "@/components/ProformaForm";

export default function ProformaDialog({ lead, open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="proforma-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-rose-600" /> Proforma Invoice
          </DialogTitle>
          <DialogDescription>Build a GST proforma invoice for this customer, preview it and download the PDF.</DialogDescription>
        </DialogHeader>
        {open && <ProformaForm lead={lead} onClose={() => onOpenChange(false)} />}
      </DialogContent>
    </Dialog>
  );
}
